// 시안 홍보자료(유튜브). 썸네일은 유튜브 i.ytimg.com 에서 직접 받는다 —
// 시안처럼 base64 로 박으면 번들이 수백 KB 커진다.
const MEDIA = [
  { title: { ko: "회사 소개", en: "About the Company" },
    lede: { ko: "메디로지스가 어떤 회사인지, 무엇을 만드는지 3분 안에 소개합니다.", en: "Who we are and what we build, in three minutes." },
    items: [
      { id: "XBgJNupNJ1I", url: "https://youtu.be/XBgJNupNJ1I", title: { ko: "메디로지스 회사소개 - 2024", en: "MEDILOGIS Company Introduction — 2024" } },
    ] },
  { title: { ko: "사용 후기", en: "User Reviews" },
    lede: { ko: "가정과 요양 시설에서 직접 사용하신 분들의 이야기입니다.", en: "Stories from people using it at home and in care facilities." },
    items: [
      { id: "nuQNHFuxsRg", url: "https://youtu.be/nuQNHFuxsRg", title: { ko: "스마트기저귀 가정요양 요양보호사 사용후기", en: "Home care worker review — Smart Diaper" } },
      { id: "9TgLZ6H3IxU", url: "https://youtu.be/9TgLZ6H3IxU", title: { ko: "스마트기저귀 요양 시설 사용후기", en: "Care facility review — Smart Diaper" } },
    ] },
  { title: { ko: "사용 방법", en: "How to Use" },
    lede: { ko: "센서 부착부터 배터리 교체까지, 따라 하기 쉽게 안내합니다.", en: "From attaching the sensor to replacing the battery — easy to follow." },
    items: [
      { id: "FsdAdVCSIHw", url: "https://youtu.be/FsdAdVCSIHw", title: { ko: "센서 단말기 부착 방법", en: "How to attach the sensor" } },
      { id: "n3unj7bCZgc", url: "https://youtu.be/n3unj7bCZgc", title: { ko: "남성형 B타입 기저귀 센서 부착 방법", en: "Attaching the sensor to a type-B men’s diaper" } },
      { id: "ARHA0yrnyjE", url: "https://youtu.be/ARHA0yrnyjE", title: { ko: "센서 배터리 교체 및 초기화 방법", en: "Replacing the battery and resetting the sensor" } },
    ] },
];

export default MEDIA;
